function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => blob ? resolve(blob) : reject(new Error('The browser could not process this image.')),
      type,
      quality
    );
  });
}

export async function processImageOnMain(blob) {
  let bitmap;
  try {
    bitmap = await createImageBitmap(blob);
    const ratio = Math.min(1, 1600 / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * ratio));
    const height = Math.max(1, Math.round(bitmap.height * ratio));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d', { alpha: false }).drawImage(bitmap, 0, 0, width, height);
    const image = await canvasToBlob(canvas, 'image/jpeg', 0.8);

    const thumbRatio = Math.min(1, 240 / Math.max(width, height));
    const thumb = document.createElement('canvas');
    thumb.width = Math.max(1, Math.round(width * thumbRatio));
    thumb.height = Math.max(1, Math.round(height * thumbRatio));
    thumb.getContext('2d', { alpha: false }).drawImage(canvas, 0, 0, thumb.width, thumb.height);
    const thumbnail = await canvasToBlob(thumb, 'image/jpeg', 0.72);
    return { image, thumbnail, width, height };
  } finally {
    bitmap?.close();
  }
}

export async function processImage(blob) {
  if (typeof Worker === 'undefined') return processImageOnMain(blob);
  const worker = new Worker(new URL('../workers/image.worker.js', import.meta.url), { type: 'module' });
  try {
    const result = await new Promise((resolve, reject) => {
      worker.onmessage = ({ data }) => data.error ? reject(new Error(data.error)) : resolve(data);
      worker.onerror = () => reject(new Error('Image processing failed. Try selecting the photo again.'));
      worker.postMessage({ blob });
    });
    return {
      image: new Blob([result.image], { type: 'image/jpeg' }),
      thumbnail: new Blob([result.thumbnail], { type: 'image/jpeg' }),
      width: result.width,
      height: result.height
    };
  } catch {
    return processImageOnMain(blob);
  } finally {
    worker.terminate();
  }
}